import axios from 'axios'
import { getAPIService } from '../../../getServerHost'

export const playMusicFile = async (payload: { group: string; file: string }) => {
  const { group, file } = payload
  axios.post(`${getAPIService}/paging/play/music/${group}/${file}`)
  return
}
